import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { RootState } from 'src/redux/store';
import { PaginationModel, SortModel } from 'src/utils/types';
import { Client } from '../client-data-types';

export interface PaginationFilterState {
    paginationModel: PaginationModel;
    searchFilter: string;
    sortModel: SortModel | null;
    selectedClient: Client | null;
    newClient: Client;
}

const initialState: PaginationFilterState = {
    paginationModel: {
        pageSize: 25,
        page: 0,
    },
    searchFilter: '',
    sortModel: null,
    selectedClient: null,
    newClient: { id: '', hosts: [], favouriteLockerEnabled: false, cui: '' } as Client,
};

const clientsSlice = createSlice({
    name: 'clients',
    initialState,
    reducers: {
        setPaginationModel: (state, action: PayloadAction<PaginationModel>) => {
            state.paginationModel = action.payload;
        },
        setSearchFilter: (state, action: PayloadAction<string>) => {
            state.searchFilter = action.payload;
        },
        setSortModel: (state, action: PayloadAction<SortModel | null>) => {
            state.sortModel = action.payload;
        },
        setSelectedClient: (state, action: PayloadAction<Client | null>) => {
            state.selectedClient = action.payload;
        },
        setNewClient: (state, action: PayloadAction<Client>) => {
            state.newClient = action.payload;
        },
        resetPaginationModel: (state) => {
            state.paginationModel = initialState.paginationModel;
        },
    },
});
export const clientsActions = { ...clientsSlice.actions };
export default clientsSlice.reducer;
export const clientsSelectors = {
    paginationModel: (state: RootState) => state.clients.paginationModel,
    searchFilter: (state: RootState) => state.clients.searchFilter,
    sortModel: (state: RootState) => state.clients.sortModel,
    selectedClient: (state: RootState) => state.clients.selectedClient,
    newClient: (state: RootState) => state.clients.newClient,
};
